import { render, staticRenderFns } from "./NotaComercialPendingBadge.vue?vue&type=template&id=0082ad7c&scoped=true"
import script from "./NotaComercialPendingBadge.vue?vue&type=script&lang=js"
export * from "./NotaComercialPendingBadge.vue?vue&type=script&lang=js"
import style0 from "./NotaComercialPendingBadge.vue?vue&type=style&index=0&id=0082ad7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0082ad7c",
  null
  
)

export default component.exports